function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

async function updateQuantity(line, quantity) {

  const body = JSON.stringify({
    'line': line,
    'quantity': quantity
  });

  fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      }).catch(function (err) {
    console.error('Something went wrong.', err);
  });
  (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));
}
$('.js-cart-popup-content').on('click','.js-delete ',function (e) {
  e.preventDefault();
  updateQuantity($(this).attr('data-line'),0).then(setTimeout(function (){
    Cart.Update_cart_popup();
    Cart.Update_cart_count();
  },400));
})
$('.js-cart-popup-content').on("click",'.counter-item:not(.counter-number)', function () {
  let _this = $(this)
  setTimeout(function () {
    let inventory = _this.closest('.js-cart-counter').attr('data-inventory');

    if(inventory == "deny"){
      let quantity = parseInt(_this.closest(".js-cart-counter").find($('.info-popup')).attr("data-available"));
      let value =  parseInt(_this.closest(".js-cart-counter").find($('.counter-number'))[0].value);
      if(value > quantity){
        _this.closest(".js-cart-counter").addClass("info-popup-open")
      }else{
        updateQuantity(_this.closest('.js-cart-counter').attr('data-line'), _this.closest(".js-cart-counter").find($('.counter-number'))[0].value).then(setTimeout(function () {
          Cart.Update_cart_popup();
          Cart.Update_cart_count();
        }, 400));
      }
      console.log("test")
    }else {
      updateQuantity(_this.closest('.js-cart-counter').attr('data-line'), _this.closest(".js-cart-counter").find($('.counter-number'))[0].value).then(setTimeout(function () {
        Cart.Update_cart_popup();
        Cart.Update_cart_count();
      }, 400));
    }
  }, 300)
});
$('.js-cart-popup-content').on("change",'.counter-number', function () {
  let _this = $(this)
  let inventory = _this.closest('.js-cart-counter').attr('data-inventory');
  if(inventory == "deny"){
    let quantity = parseInt(_this.closest(".js-cart-counter").find($('.info-popup')).attr("data-available"));
    let value =  parseInt(_this[0].value);
    if(value > quantity){
      _this.closest(".js-cart-counter").addClass("info-popup-open")
    }else{
      updateQuantity(_this.closest('.js-cart-counter').attr('data-line'), _this[0].value).then(setTimeout(function () {
        Cart.Update_cart_popup();
        Cart.Update_cart_count();
      }, 400));
    }
  }else {
    updateQuantity(_this.closest('.js-cart-counter').attr('data-line'), _this[0].value).then(setTimeout(function () {
      Cart.Update_cart_popup();
      Cart.Update_cart_count();
    }, 400));
  }
});
$('.cart-items').on('click','.js-delete ',function (e) {
  e.preventDefault();
  console.log("click")
  let _this=$(this);
  updateQuantity($(this).attr('data-line'),0).then(setTimeout(function (){
    Cart.Update_cart();
    Cart.Update_cart_count();
    // _this.closest('.modal-dialog').find($('.product-addToCart__close')).click();
    // $('body').removeClass("modal-open");
    // $('.modal-backdrop.fade.show').remove();
  },400));
 
setTimeout(() => {
            location.reload();
          }, 500);

})
$('.cart-items').on("click",'.counter-item:not(.counter-number)', function () {
  let _this = $(this)
  setTimeout(function () {
    let inventory = _this.closest('.js-cart-counter').attr('data-inventory');
    if(inventory == "deny"){
      let quantity = parseInt(_this.closest(".js-cart-counter").find($('.info-popup')).attr("data-available"));
      let value =  parseInt(_this.closest(".js-cart-counter").find($('.counter-number'))[0].value);
      if(value > quantity){
        _this.closest(".js-cart-counter").addClass("info-popup-open")
      }else{
        updateQuantity(_this.closest('.js-cart-counter').attr('data-line'), _this.closest(".js-cart-counter").find($('.counter-number'))[0].value).then(setTimeout(function () {
          Cart.Update_cart();
          Cart.Update_cart_count();
        }, 400));
      }
    }else {
      updateQuantity(_this.closest('.js-cart-counter').attr('data-line'), _this.closest(".js-cart-counter").find($('.counter-number'))[0].value).then(setTimeout(function () {
        Cart.Update_cart();
        Cart.Update_cart_count();
      }, 400));
    }
  }, 300)
});
$('.cart-items').on("change",'.counter-number', function () {
  let _this = $(this)
  let inventory = _this.closest('.js-cart-counter').attr('data-inventory');
  if(inventory == "deny"){
    let quantity = parseInt(_this.closest(".js-cart-counter").find($('.info-popup')).attr("data-available"));
    let value =  parseInt(_this[0].value);
    if(value > quantity){
      _this.closest(".js-cart-counter").addClass("info-popup-open")
    }else{
      updateQuantity(_this.closest('.js-cart-counter').attr('data-line'), _this[0].value).then(setTimeout(function () {
        Cart.Update_cart();
        Cart.Update_cart_count();
      }, 400));
    }
  }else {
    updateQuantity(_this.closest('.js-cart-counter').attr('data-line'), _this[0].value).then(setTimeout(function () {
      Cart.Update_cart();
      Cart.Update_cart_count();
    }, 400));
  }
});

// $('.js-header-cart').on('change','.ajaxcart__qty-num',function () {
//   updateQuantity($(this).attr('data-line'),$(this).val()).then(setTimeout(function (){
//     Cart.getCartDrower();
//     Cart.Update_cart_count();
//   },400));
// })